var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1141 3.88618C12.0896 2.90913 13.672 2.90853 14.6483 3.88484L16.7248 5.96139C17.6928 6.92937 17.7028 8.49642 16.7474 9.47676L9.05308 17.3711C8.42594 18.0146 7.5658 18.3774 6.66763 18.3774L4.37418 18.3773C3.18969 18.3772 2.24375 17.3898 2.29357 16.2055L2.39203 13.8646C2.42714 13.0299 2.77405 12.2388 3.36413 11.6479L11.1141 3.88618ZM13.4706 5.06424C13.1452 4.73881 12.6178 4.73901 12.2926 5.06469L11.0543 6.30486L14.3244 9.57493L15.5547 8.31258C15.8732 7.9858 15.8699 7.46345 15.5472 7.14079L13.4706 5.06424ZM4.54264 12.8264L9.87667 7.48426L13.161 10.7686L7.86043 16.207C7.54686 16.5287 7.11679 16.7101 6.66771 16.7101L4.37425 16.71C4.13735 16.71 3.94817 16.5125 3.95813 16.2756L4.05659 13.9348C4.07415 13.5174 4.2476 13.1219 4.54264 12.8264ZM17.0964 18.3159C17.5565 18.3159 17.9294 17.9426 17.9294 17.4822C17.9294 17.0218 17.5565 16.6486 17.0964 16.6486H11.995C11.5349 16.6486 11.162 17.0218 11.162 17.4822C11.162 17.9426 11.5349 18.3159 11.995 18.3159H17.0964Z",
    fill: "#647184"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.767579f57d484212fc9550282de3706d.svg";
export { ForwardRef as ReactComponent };